// src/ui/controls/toggle.ts

export interface ToggleOpts {
  label: string;
  value: boolean;
  onChange: (v: boolean) => void;
}

export function createToggle(o: ToggleOpts): HTMLLabelElement {
  const wrap = document.createElement('label');
  wrap.className = 'toggle-row';
  const cb = document.createElement('input');
  cb.type = 'checkbox';
  cb.checked = o.value;
  cb.addEventListener('change', () => o.onChange(cb.checked));
  const span = document.createElement('span');
  span.textContent = o.label;
  wrap.append(cb, span);
  return wrap;
}
